// extracted by css-extract-rspack-plugin
var _1 = "fkOqbVp2LGEv9zO6";
var _2 = "J1NteiSNccPqEnqZ";
export { _1 as "linkStyle", _2 as "underlineStyle" }
